import LayoutPadrao from '../layouts/LayoutPadrao.vue'
import AssistenciaTecnicaView from '@/views/assistencia/AssistenciaTecnicaView.vue'

// Auth check function
const isAuthenticated = (to, from, next) => {
  const isLoggedIn = localStorage.getItem('user') !== null
  if (isLoggedIn) next()
  else next('/login')
}

export default {
  path: '/',
  component: LayoutPadrao,
  beforeEnter: isAuthenticated,
  children: [
    {
      path: 'assistencia-tecnica',
      name: 'AssistenciaTecnica',
      component: AssistenciaTecnicaView,
      meta: { 
        requiresAuth: true,
        title: 'Assistência Técnica',
        nome_fisico: 'assistencia-tecnica'
      },
    },
  ],
}
